<template>
  <svg width="20"
       height="19"
       viewBox="0 0 20 19"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M9.99121 18.7422C14.9746 18.7422 19.0879 14.6289 19.0879 9.6543C19.0879 4.67969 14.9658 0.566406 9.98242 0.566406C5.00781 0.566406 0.90332 4.67969 0.90332 9.6543C0.90332 14.6289 5.0166 18.7422 9.99121 18.7422ZM9.98242 14.7871C9.74512 14.7871 9.56934 14.6113 9.56934 14.3652V13.7412C8.25977 13.6357 7.29297 12.9502 7.0293 11.9834C6.99414 11.8691 6.97656 11.7637 6.97656 11.6582C6.97656 11.2891 7.23145 11.0342 7.60938 11.0342C7.92578 11.0342 8.13672 11.2012 8.26855 11.5264C8.40918 12.0625 8.83984 12.458 9.56934 12.5635V10.1729L9.41113 10.1377C7.89062 9.78613 7.09961 9.08301 7.09961 7.89648C7.09961 6.61328 8.12793 5.73438 9.56934 5.60254V4.9873C9.56934 4.73242 9.74512 4.56543 9.98242 4.56543C10.2197 4.56543 10.4043 4.74121 10.4043 4.9873V5.60254C11.6348 5.72559 12.5488 6.40234 12.7949 7.34277C12.8213 7.44824 12.8477 7.55371 12.8477 7.65918C12.8477 8.01074 12.5928 8.26562 12.2236 8.26562C11.8984 8.26562 11.6875 8.08105 11.5557 7.78223C11.3799 7.24609 10.9844 6.90332 10.4043 6.79785V9.05664L10.6064 9.10059C12.1973 9.39941 12.9971 10.1289 12.9971 11.377C12.9971 12.7656 11.8896 13.6182 10.4043 13.75V14.3652C10.4043 14.6113 10.2197 14.7871 9.98242 14.7871ZM9.56934 8.8457V6.78906C8.875 6.90332 8.45312 7.31641 8.45312 7.80859C8.45312 8.30078 8.77832 8.61719 9.50781 8.82812L9.56934 8.8457ZM10.4043 10.375V12.5635C11.2393 12.4668 11.6523 12.0449 11.6523 11.4736C11.6523 10.9639 11.3623 10.6299 10.5713 10.4189L10.4043 10.375Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'SalesIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
